export const cycleRoutesData = {
  title: "Cyklotrasy",
  introduction:
    "Trasy jsou pouze doporučené a účastníci si je mohou dle potřeb upravit. Každý se účastní na vlastní riziko.",
  downloadMapsComment: "Všechny trasy ke stažení.",
  downloadMapLink: "Odkaz na mapy.cz",
  mapsPath: "https://mapy.cz/s/ladovasete",
  routeDetails: [
    {
      subtitle: "57 km",
      routeDescription:
        "Hlučín - Darkovičky (kontrola 4) - Šilheřovice - Hať - Píšť - Chuchelná - Albertovec - Bolatice (kontrola 5) - Bohuslavice - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/remogocepo",
      src: "/images/routes/cyklotrasy.png",
    },
  ],
};
